var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.trafficinfo = new function() {
    var self = this;

    this.init = function() {
        if ($('#traffic-information').length) {
            self.initSort();
            self.filterRoute();
            self.trafficInfo();
        }
    };

    this.trafficInfo = function() {
        $.ajax({
            url: '/umbraco/api/BreakingNewsApi/GetTrafficInfo',
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                $('#trafficInformationContainer').prepend(data.Content);

                $('#trafficInformationContainer .js-read-more')
                    .click(function () {
                        $(this).siblings('.js-accordion').stop().slideToggle();
                        $(this).siblings('.js-accordion-always').stop().slideToggle();
                        if ($(this).text() == 'Skjul') {
                            $(this).text('Læs mere');
                        } else {
                            $(this).text('Skjul');
                        }
                    });
            }
        });
    };

    this.initSort = function() {
        $('.bus-route-node').show();

        if ($('#traffic-sort').length) {
            $('.js-select-option').click(function() {
                var target = $(this).attr('id');
                $('#label-select').hide();
                if (target == '') {
                    $('.group-header').show();
                    $('.group-details').show();
                    $('.group-24-hours').show();
                    $('.group-details').show();
                    $('.bus-route-node').show();

                } else {
                    //$(".group-header").hide();
                    //$(".group-24-hours").hide();
                    var potentials = $('.group-details').find('.bus-route-node');
                    for (var i = 0; i < potentials.length; i++) {
                        var element = $(potentials[i]);
                        if (element.data(target) == 0) {
                            element.hide();
                        } else {
                            element.show();
                        }
                    }

                    var potentials = $('.group-24-hours').find('.bus-route-node');
                    for (var i = 0; i < potentials.length; i++) {
                        var element = $(potentials[i]);
                        if (element.data(target) == 0) {
                            element.hide();
                        } else {
                            element.show();
                        }
                    }

                }
                $('#rute-filter').val('');
            });
        }
    };

    this.filterRoute = function() {
        $('#filter-btn').click(function() {
            self.filter();
        });
    };
    this.filter = function() {
        var input = $('#rute-filter').val();
        input = input.replace(/\D/g, '');

        if (input.length) {
            var show = '.route-' + input.toLowerCase();

            $('.bus-route-node').hide();
            $(show).show();
        } else {
            self.initSort();
        }
    };

    $('#rute-filter').keypress(function(e) {
        if (e.which === 13) {
            self.filter();
        }
    });
};


